import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import trLabels from "react-phone-number-input/locale/tr.json";
import enLabels from "react-phone-number-input/locale/en.json";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Locale-aware phone input with an international country picker (both TR and EN).
 * Bayrağın yanında ülke kodu (+90 gibi) her zaman görünür; değer E.164 olarak
 * tutulur ("+905321234567"). Geçersiz numaralarda hata çerçevesi gösterilir.
 */
export default function LocalePhoneInput({
  value,
  onChange,
  placeholder,
  className = "",
  testid = "phone-input",
  defaultCountry = "TR",
  invalid = false,
}) {
  const { locale } = useLanguage();
  const isEn = locale === "en";

  return (
    <PhoneInput
      defaultCountry={defaultCountry}
      countryCallingCodeEditable={false}
      international
      withCountryCallingCode
      limitMaxLength
      labels={isEn ? enLabels : trLabels}
      value={value || ""}
      onChange={(v) => onChange(v || "")}
      placeholder={placeholder || (isEn ? "532 123 45 67" : "532 123 45 67")}
      className={`kahu-phone-input ${invalid ? "kahu-phone-invalid" : ""} ${className}`}
      data-testid={testid}
    />
  );
}
